export const WORKFLOW_MAP: {
  [key: string]: boolean;
} = {
  '3ds': false,
  alternative: false,
  merchanttransaction: true,
  callcenter: false,
  enrollments: true,
  activation: true,
  testingharness: false,
  notFound: false,
};
